import React from "react";
import { Button, Stack } from "@mui/material";
import {
  ActivityLogTable,
  ContentLayout,
  HeaderBreadcrumbs,
  usePermission,
} from "../../../shared";
import { useCustomerSegmentation, useSegmentDetails } from "../hooks";
import { SegmentBasicDetails, SegmentReferences } from "../components";
import { useParams } from "react-router-dom";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export const SegmentDetails = () => {
  const {
    state,
    breadcrumbLinks,
    onExport,
    onEdit,
    onRerun,
    onPreviewGotoPage,
    onPreviewSetPageSize,
    onPreviewSearch,
    deleteSegment,
  } = useSegmentDetails();
  const { toggleDeleteDialog } = useCustomerSegmentation({ list: false });

  const { id } = useParams();
  const canModify = usePermission("segment-modify");
  const canDelete = usePermission("segment-delete");
  const canViewActivityLog = usePermission("activity-logs");

  const tabs = [
    {
      label: "Basic Details",
      value: "1",
      panel: (
        <SegmentBasicDetails
          state={state}
          onPreviewGotoPage={onPreviewGotoPage}
          onPreviewSetPageSize={onPreviewSetPageSize}
          onPreviewSearch={onPreviewSearch}
          onExport={onExport}
          onRerun={onRerun}
        />
      ),
    },
  ];

  if (canViewActivityLog) {
    tabs.push({
      label: "Activity Log",
      value: "2",
      panel: <ActivityLogTable subjectType="segment" id={id} />,
    });
  }

  tabs.push({
    label: "References",
    value: "3",
    panel: (
      <SegmentReferences segmentId={id} referenceTypes={state.referenceTypes} />
    ),
  });

  return (
    <ContentLayout
      title={state?.data?.name || "Segment Details"}
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbLinks} />}
      rightContent={
        <Stack direction="row" gap="12px">
          {canDelete && (
            <Button
              variant="text"
              size="small"
              onClick={() => toggleDeleteDialog(state.data, deleteSegment)}
              sx={{ height: "40px", width: "40px" }}
              disabled={state.isSystem || state.isSegmentDeleting}
            >
              <img
                src="/icons/ic_delete_blue.svg"
                alt="delete"
                style={{
                  opacity: state.isSystem || state.isSegmentDeleting ? 0.5 : 1,
                }}
              />
            </Button>
          )}
          {canModify && (
            <Button
              variant="text"
              size="small"
              onClick={onEdit}
              disabled={state.isSystem || state.isSegmentDeleting}
            >
              Edit
            </Button>
          )}
        </Stack>
      }
      tabProps={{
        label: "segmentDetails",
        list: tabs,
      }}
    />
  );
};
